import { Link } from 'react-router-dom';
import { HelpCircle, ArrowRight } from 'lucide-react';
import useCommonContent from '../hooks/useCommonContent';
import useLocale from '../hooks/useLocale';
import { getLocalizedPath } from '../data/i18nRoutes';

/** Lightweight FAQ link — replaces full FAQ accordion on every page. */
const FAQBanner = () => {
  const { t } = useCommonContent();
  const locale = useLocale();
  const faqPath = getLocalizedPath('/faq', locale);

  return (
    <section className="py-8 bg-slate-100 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800">
      <div className="max-w-4xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3 text-center sm:text-left">
          <HelpCircle className="w-6 h-6 text-blue-600 flex-shrink-0" />
          <p className="text-slate-700 dark:text-slate-300 text-sm font-medium">
            {t('faq.prompt')}
          </p>
        </div>
        <Link
          to={faqPath}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-xl transition-colors"
        >
          {t('faq.cta')}
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
};

export default FAQBanner;
